import { lighten } from 'polished'
import styled, { css } from 'styled-components'

import { ButtonAsync, muiRipple } from '@subaio/components'

import { helpers } from 'styles'

export const solidStyle = css`
	color: ${helpers.color.textContrast};
	background-color: ${helpers.color.primary};
	-webkit-font-smoothing: antialiased;
	font-weight: 500;
	font-family: ${helpers.font.family.header};
	font-size: ${helpers.font.size.base};
	line-height: 1.5;
	border-radius: 40px;
	min-width: 125px;
	height: 40px;
	padding-left: 16px;
	padding-right: 16px;
	transition: color 0.2s, background-color 0.2s;
	isolation: isolate;
	margin: 0;

	&:is(:focus-visible, :hover) {
		background-color: ${({ theme }) => lighten(0.1, theme.color.primary)};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:disabled {
		background-color: ${helpers.color.disabledContrast};
		color: ${helpers.color.disabled};
	}

	${muiRipple()}
`

export const ButtonSolid = styled(ButtonAsync)`
	${solidStyle}
`
